import React, { Component } from 'react';
import { Card, CardBody, CardLink, Button, CardHeader, Modal, ModalHeader, ModalBody, Col, Row, Badge, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label, Form, FormGroup, Input } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModGrupo from '../../Paginas/Admin/modGrupo'
import validaciones from '../../Auxiliares/validaciones'
import Tarjeta from './mensajeCard'
import Tarjeta2 from './tareaCard'

class gruposCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOptionsOpen: false,
            isMessageAddModalOpen: false,
            isMessageModalOpen: false,
            isTaskAddModalOpen: false,
            isTaskModalOpen: false,
            isDelModalOpen: null,
            isModModalOpen: null,
            mensajes: [],
            tareas: [],

            grupoId: this.props.id,
            mensaje: null,
            titulo: null,
            descripcion: null,

            errors: {}
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
        this.toggleOptions = this.toggleOptions.bind(this)
        this.toggleMessages = this.toggleMessages.bind(this)
        this.toggleTask = this.toggleTask.bind(this)
        this.toggleAddMessage = this.toggleAddMessage.bind(this)
        this.toggleAddTask = this.toggleAddTask.bind(this)
        this.fetchMensajes = this.fetchMensajes.bind(this)
        this.fetchTareas = this.fetchTareas.bind(this)
        this.submitMensaje = this.submitMensaje.bind(this)
        this.submitTarea = this.submitTarea.bind(this)
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    toggleOptions() {
        this.setState(prevState => ({
            isOptionsOpen: !prevState.isOptionsOpen
        })
        )
    }

    toggleAddMessage() {
        this.setState(prevState => ({
            isMessageAddModalOpen: !prevState.isMessageAddModalOpen
        })
        )
    }

    toggleAddTask() {
        this.setState(prevState => ({
            isTaskAddModalOpen: !prevState.isTaskAddModalOpen
        })
        )
    }

    eliminar = (id) => {
        Fetch('/api/deleteGrupo', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizar();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;
                    default:
                        break;
                }
            })
    }

    fetchMensajes() {
        const { id } = this.props

        Fetch('/api/getMensajes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.setState({ mensajes: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 605:
                        console.log('Este listado esta vacio')
                        this.setState({ mensajes: [] })
                        break;
                    
                    default:
                        break;
                }
            })
    }

    fetchTareas() {
        const { id } = this.props

        Fetch('/api/getTareas', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.setState({ tareas: response.data })
                console.log(response.data)
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 605:
                        console.log('Este listado esta vacio')
                        this.setState({ tareas: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    toggleMessages() {
        this.fetchMensajes();
        this.setState(prevState=>({
            isMessageModalOpen: !prevState.isMessageModalOpen
        })
        )
    }

    toggleTask() {
        this.fetchTareas();
        this.setState(prevState=>({
            isTaskModalOpen: !prevState.isTaskModalOpen
        })
        )
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch([field].toString()){
                case 'mensaje':
                    if (validaciones.validar_titulo(this.state.mensaje)) {
                        value = validaciones.validar_titulo(this.state.mensaje)
                        this.setState(prevState => ({ errors: { ...prevState.errors, mensaje: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).mensaje) });
                    }
                break;

                case 'titulo':
                    if (validaciones.validar_titulo(this.state.titulo)) {
                        value = validaciones.validar_titulo(this.state.titulo)
                        this.setState(prevState => ({ errors: { ...prevState.errors, titulo: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).titulo) });
                    }
                break;
                case 'descripcion':
                    if (validaciones.validar_titulo(this.state.descripcion)) {
                        value = validaciones.validar_titulo(this.state.descripcion)
                        this.setState(prevState => ({ errors: { ...prevState.errors, descripcion: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).descripcion) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    submitMensaje(e){
        e.preventDefault();
        
        const { grupoId, mensaje } = this.state
        
        Fetch('/api/addMensaje', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ grupoId, mensaje })
        })
            .then(response => {
                this.fetchMensajes();
                this.toggleAddMessage()
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log(err)
                        break;
                    
                    default:
                        break;
                }
            })
    }
    
    submitTarea(e){
        e.preventDefault();
        
        const { grupoId, titulo, descripcion } = this.state
        
        Fetch('/api/addTarea', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ grupoId, titulo, descripcion })
        })
            .then(response => {
                this.fetchTareas();
                this.toggleAddTask()
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log(err)
                        break;
                    
                    default:
                        break;
                }
            })
    }

    render() {
        return (
            <div>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col className="col-9 align-self-center">{this.props.nombre}</Col>
                            <Col className="col-1">
                                <Dropdown isOpen={this.state.isOptionsOpen} toggle={this.toggleOptions}>
                                    <DropdownToggle>&#8942;</DropdownToggle>

                                    <DropdownMenu>
                                        <DropdownItem onClick={() => this.toggleDel(this.props)} ><Row><Col className="col-1 d-inline"><Badge color="danger">X</Badge></Col><Col className="col-8 d-inline">Eliminar</Col></Row></DropdownItem>
                                        <DropdownItem onClick={() => this.toggleMessages()}><Row><Col className="col-1 d-inline"><Badge color="primary">✉</Badge></Col><Col className="col-8 d-inline">Mensajes</Col></Row></DropdownItem>
                                        <DropdownItem onClick={() => this.toggleTask()}><Row><Col className="col-1 d-inline"><Badge color="success">⌸</Badge></Col><Col className="col-8 d-inline">Tarea</Col></Row></DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </Row>
                    </CardHeader>

                    <CardBody onClick={() => { this.toggleMod(this.props) }} className="clicable overflow-auto" style={{ height: '120px' }} >
                        <ul class="list-group">
                            {this.props.integrantes.map(elem => (<li class="list-group-item">{elem.nombre}</li>))}
                        </ul>

                    </CardBody>
                </Card>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar este grupo?
                                    <div className="font-weight-bold">
                                        {this.props.doc}
                                    </div>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Modificar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 border-0">
                                    <div>
                                        <ModGrupo id={this.props.id} nombre={this.props.nombre} integrantes={this.props.integrantes} cerrar={() => this.toggleMod()} actualizar={this.props.actualizar} usuarios={this.props.usuarios} />
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isMessageModalOpen} toggle={() => this.toggleMessages()}
                    className="modal-lg">
                    <ModalHeader toggle={() => this.toggleMessages()}>Mensajes</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="border-0">
                                    <Col className="text-right col-12">
                                        <Button className="w-25 float-right bg-light text-dark" onClick={() => this.toggleAddMessage()}>Agregar</Button>
                                    </Col>
                                    <Row className="mt-3 overflow-auto" style={{ height: '600px' }} >
                                        {this.state.mensajes.length > 0 ? this.state.mensajes.map(index => (<Col sm="6" className="mb-4"><Tarjeta id={index._id} mensaje={index.mensaje} fechaHora={index.fechaHora} actualizarLista={this.fetchMensajes} /></Col>)) : <Col>Vacio</Col>}
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isMessageAddModalOpen} toggle={() => this.toggleAddMessage()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleAddMessage()}>Agregar Mensaje</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Form onSubmit={this.submitMensaje}>
                                    <FormGroup>
                                        <Label>Grupo</Label>
                                        <Input type="text" name="grupoId" disabled value={this.props.nombre} className="w-100" />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Mensaje</Label>
                                        <Input type="textarea" name="mensaje" onChange={this.setValue.bind(this, 'mensaje')} className="w-100"/>
                                    </FormGroup>

                                    <Input type="submit" name="guardar" value="Guardar" className="w-100 bg-primary text-light">Enviar</Input>
                                </Form>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                
                <Modal isOpen={this.state.isTaskModalOpen} toggle={() => this.toggleTask()}
                    className="modal-lg">
                    <ModalHeader toggle={() => this.toggleTask()}>Tareas</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="border-0">
                                    <Col className="text-right col-12">
                                        <Button className="w-25 float-right bg-light text-dark" onClick={() => this.toggleAddTask()}>Agregar</Button>
                                    </Col>
                                    <Row className="mt-3 overflow-auto" style={{ height: '600px' }} >
                                        {this.state.tareas.length > 0 ? this.state.tareas.map(index => (<Col sm="6" className="mb-4"><Tarjeta2 id={index._id} nombre={this.props.nombre} titulo={index.titulo} descripcion={index.descripcion} completado={index.completado} fechaHora={index.fechaHora} actualizarLista={this.fetchTareas} /></Col>)) : <Col>Vacio</Col>}
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isTaskAddModalOpen} toggle={() => this.toggleAddTask()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleAddTask()}>Agregar Tarea</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Form onSubmit={this.submitTarea}>
                                    <FormGroup>
                                        <Label>Grupo</Label>
                                        <Input type="text" name="grupoId" disabled value={this.props.nombre} className="w-100" />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Titulo</Label>
                                        <Input type="text" name="titulo"  onChange={this.setValue.bind(this, 'titulo')} className="w-100" />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Descripcion</Label>
                                        <Input type="textarea" name="mensaje" onChange={this.setValue.bind(this, 'descripcion')} className="w-100"/>
                                    </FormGroup>

                                    <Input type="submit" name="guardar" value="Guardar" className="w-100 bg-primary text-light">Enviar</Input>
                                </Form>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar este grupo?
                                    <div className="font-weight-bold">
                                        {this.props.doc}
                                    </div>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}
export default gruposCard